module.exports = __webpack_public_path__ + "img/index-info2.15a9c443.jpg";